import { createContext, RefObject } from 'react';
import { Toast, ToastMessage } from 'primereact/toast';

export type ToastContextType = {
  toastRef: RefObject<Toast>;
  getToastMessage: (id: string) => ToastMessage | undefined;
  setToastMessage: (id: string, message: ToastMessage) => void;
  deleteToastMessage: (id: string) => void;
  clearToastMap: () => void;
} | null;

export const ToastContext = createContext<ToastContextType>(null);
